<div class="terms-of-use-dialog" [@.disabled]="true">
  <div class="tabs-container">
    <div *ngFor="let disclaimer of disclaimers$ | async; let i = index">
      <section id="section{{ disclaimer.sequence }}">
        <input type="radio" name="sections" id="option{{ disclaimer.sequence }}" [checked]="i===0" />

        <label *ngIf="disclaimer.isMainDisclaimer; else versionLabel" for="option{{ disclaimer.sequence }}">{{'module.dashboard.termsOfUseDialog.mainTabText' | translate}}</label>
        <ng-template #versionLabel>
          <label for="option{{ disclaimer.sequence }}"> Version {{disclaimer.version}}</label>
        </ng-template>

        <article>
          <iframe class="iframe-content main" [src]="disclaimer.deltaFile | urlSanitizer" title="iframe"></iframe>
          <div class="button-container" *ngIf="disclaimer.isMainDisclaimer">
            <div class="text-container">
              {{ 'module.dashboard.termsOfUseDialog.buttonContainerDescriptionText' | translate }}
            </div>
            <div class="buttons">
              <button class="btn btn-outline-secondary download-button" (click)="downloadPdf()">
                {{ 'module.dashboard.termsOfUseDialog.downloadAnbButtonText' | translate }}
              </button>
              <button class="btn btn-primary button-border" (click)="accept()">
                {{ 'module.dashboard.termsOfUseDialog.acceptAnbButtonText' | translate }}
              </button>
              <button class="btn btn-outline-primary margin" (click)="decline()">
                {{ 'module.dashboard.termsOfUseDialog.declineAnbButtonText' | translate }}
              </button>
            </div>
          </div>
        </article>
      </section>
    </div>
  </div>
</div>
